<ngx-slick-carousel class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
>
  <div class="slide" ngxSlickItem *ngFor="let slide of slides">
    <p>{{ slide.text }}</p>
    <img src="{{ slide.img }}" alt="">
  </div>
</ngx-slick-carousel>
